import React, {CSSProperties} from 'react'

import {progressBarStyle} from './styles.js'

interface ProgressBarProps {
    style?: CSSProperties
    now?: number
    /** 100 by default */
    max?: number
}

/** A bar that fills with now/max and shows the percentage in the middle. No outer margins. */
export default function ProgressBar({style, now, max}: ProgressBarProps) {
    const percentage = Math.min(100, ((now || 0) / (max || 100)) * 100)
    const rounded = Math.trunc(percentage) || 0

    const defaultStyle: CSSProperties = {
        position: 'relative',
        width: '100%',
        background: progressBarStyle.background,
        borderRadius: progressBarStyle.radius,
        height: progressBarStyle.height,
        ...style
    }

    return (
        <div role='progressbar' aria-valuemin={0} aria-valuemax={100} aria-valuenow={rounded} style={defaultStyle}>
            <div style={{position: 'absolute', width: `${percentage}%`, background: progressBarStyle.fill, borderRadius: progressBarStyle.radius, height: progressBarStyle.height}} />
            <div style={{position: 'absolute', zIndex: 10, fontSize: progressBarStyle.fontSize, left: '50%', top: 3, transform: 'translateX(-50%)'}}>{`${rounded} %`}</div>
        </div>
    )
}
